module.exports = __webpack_public_path__ + "img/wholesale-term-modal-image-02.fbe3c24.svg";